





































































































































































































































































































































































































































import VueOptions from '@utils/VueOptions'
import EditorContent from '@components/EditorContent'
import PricingModel from '@services/PricingModel'
import LoadingIndicator from '@/components/LoadingIndicator'
import EventHero from '@ui/Event/EventHero'
import EventServices from '@ui/Event/EventServices'
import EventBrandPartners from '@ui/Event/EventBrandPartners'
import EventMap from '@ui/Event/EventMap'
import TagBar from '@ui/TagBar'
import Carousel from '@ui/Carousel'
import UpdateGeoFenceTimeFrameModal from '@triggers/Event/SetGeoFenceTimeFrameTrigger'

settings =
  name: 'EventDetail'

  vue:
    props: ['event', 'campaign', 'nearbyPOIs', 'actions', 'options']
    components: { LoadingIndicator, EventHero, EventServices, EventBrandPartners, EventMap, TagBar, Carousel, EditorContent }

    data: ->
      dataAmenities: ['wifi', 'tent', 'chairs', 'power', 'ice', 'tables', 'lighting', 'parking', 'trash_bins', 'recycle_bins', 'other']

    computed:
      member: -> @$store.member

      isSingleDayEvent: -> dayjs(@event.local_start_day).isSame(dayjs(@event.local_end_day), 'day')
      isFavorited: -> @event.event_set_id in (@campaign?.favorite_event_set_ids || [])
      isRecommended: -> @campaign?.recommended_event_set_ids?.includes @event.event_set_id
      isRecentlyPublished: -> @campaign?.recently_published_event_ids?.includes @event.id

      hostName: -> @ctxHost(@event).name

      eventDate: -> @$options.filters.formatDateWindow(@event.local_start_day, @event.local_end_day)
      eventTime: -> @$options.filters.formatTimeWindow(@event.local_start_time, @event.local_end_time)

      listingTypes: -> @event?.types || []
      listingCategories: ->
        @event.category_tags.map((type) => @$options.filters.formatListingCategory(type))
      eventActivities: ->
        @event.activity_tags.map((activity) => @$options.filters.formatTitle(activity))

      eventTags: -> @event.audience_tags || []
      eventSpaces: -> Object.values(@event?.spaces) or []

      audienceDemographics: -> @event.audience_demographics or {}
      hasAudienceGender: -> !!Object.values(@audienceDemographics.gender or {}).length
      hasAudienceInsights: ->
        @eventTags.length or @hasAudienceGender or Object.values(@audienceDemographics).length

      hasPartnerRestrictions: ->
        { drink = [], food = [], onsite = [] } = @event.partner_restrictions || {}
        [...drink, ...food, ...onsite].length

      hasAdditionalOrganizerTOS: -> @event.partner_additional_terms?.length

      eventReviews: -> @event.reviews

      location: -> @event?.venue?.location || {}
      hasVenue: -> @location.setting not in ['national', 'virtual']

      catex: -> Object.values(@event.catex || {}).filter((catex) => catex.prohibited or @categoryIsExclusive(catex))
      secretBrandDomains: -> Object.keys(@marketplace?.secret_brands || {})
      sponsorSet: -> @ctxEventSet(@event).sponsor_set || []

      onSiteSpaceOptions: -> ['booth_10x10', 'booth_10x20', 'booth_20x40', 'booth_40x60']

      tagOptionsForListingTypes: ->
        {
          bar: {
            theme: 'secondary',
            max: 12,
          },
          tag: {
            theme: 'secondary',
            format: 'formatListingType',
            maxLength: 12,
          }
        }

      showSamplingPricing: -> !!@options?.showSamplingPricing
      bookedSamplingPrice: -> @options?.bookedSamplingPrice

      pricingTable: -> @options?.pricingTable || {}
      foodDistribuitionPrice: -> parseFloat(@pricingTable.food_distribution?.price_in_cents) / 100 || 0
      foodDistribuitionMultiServingPrice: -> parseFloat(@pricingTable.food_multi_serving_distribution?.price_in_cents) / 100 || 0
      drinkDistribuitionPrice: -> parseFloat(@pricingTable.drink_distribution?.price_in_cents) / 100 || 0
      promoDistribuitionPrice: -> parseFloat(@pricingTable.promo_distribution?.price_in_cents) / 100 || 0
      promoAddonDistribuitionPrice: -> parseFloat(@pricingTable.addon_promo_distribution?.price_in_cents) / 100 || 0

    methods:
      isMeSponsoring: (sponsor) ->
        { formatDomain } = @$options.filters
        isSameCampaignDomain = formatDomain(sponsor.domain) is formatDomain(@campaign?.brand_info.domain)
        isSameSponsorDomain = formatDomain(sponsor.domain) is formatDomain(@member?.sponsor?.domain)
        isSameCampaignDomain || isSameSponsorDomain

      isSecretBrand: (sponsor) ->
        { formatDomain } = @$options.filters
        formatDomain(sponsor.domain) in @secretBrandDomains

      hiClose: -> @$router.push(@$route.path.split('/events/')[0])

      categoryIsExclusive: (catex) -> catex.sponsors?.length > 0
      imageForSpace: (space) -> space.image || "#{process.env.VUE_APP_IMAGE_ENDPOINT}/spaces/#{space.type}.png"

      spaceTypeIsProductSampling: (space) -> 'product_sampling' is space.type
      spaceTypeIsOnsiteSpace: (space) -> @onSiteSpaceOptions.includes space.type

      displayMaxPalletForSpace: (space) ->
        (@spaceTypeIsProductSampling(space) or @spaceTypeIsOnsiteSpace(space)) and space.max_pallets_count > 0

      displayLocationOfSpaces: (space) ->
        @spaceTypeIsOnsiteSpace(space) and @event.venue.where_spaces_are?.trim().length

      priceForVideoWall: -> PricingModel.priceForVideoWall @event, @marketplace.standard_pricing_table

      hiFavoriteEventTrigger: -> @actions.favoriteEventTrigger @event
      hiUnfavoriteEventTrigger: -> @actions.unfavoriteEventTrigger @event

      partnerBuy: -> { ...@getAppSession('partnerBuy', { bookings: {} }) }

      hiAddBookingSpace: (space, pricingModel) ->
        @actions.addBookingSpace space, pricingModel 

      hiRemoveBookingSpace: (spaceName) ->
        @actions.removeBookingSpace spaceName

export default VueOptions.vue settings
